module.exports = __webpack_public_path__ + "img/i-hospital-4.26bc5c73.png";